import Axios from 'axios';

export const URI = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001/api';

export const axios = Axios.create({
    withCredentials: true,
    baseURL: URI,
    headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' },
    credentials: 'include'
});

export const setAuthToken = value => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${value}`;
};

export const clearAuthToken = () => {
    delete axios.defaults.headers.common['Authorization'];
};

const API = {};

axios.interceptors.response.use(
    function (res) {
        return res;
    },
    function (error) {
        console.log(error?.response?.data?.error);
        return Promise.reject(error);
    }
);

/** Auth */

API.refreshToken = () => axios.post(`${URI}/auth/accessToken`);
API.login = ({ email, password }) => axios.post(`${URI}/auth/login`, { email, password });
API.logout = () => axios.post(`${URI}/auth/logout`);
API.forgotPassword = ({ email }) => axios.post(`${URI}/auth/forgotPassword/${email}`);
API.recoverPassword = ({ recoverPasswordId, password }) =>
    axios.post(`${URI}/auth/recoverPassword/${recoverPasswordId}`, { password });

API.signup = ({ email, password, firstName, lastName, type }) =>
    axios.post('/auth/signup', {
        username: 'test' + Math.random() * 1000000,
        email,
        password,
        firstName,
        lastName,
        type
    });

API.createAccount = ({ email, firstName, lastName, type }) =>
    axios.post('/auth/createAccount', {
        email,
        firstName,
        lastName,
        type
    });

API.activateAccount = userId => axios.post(`/auth/${userId}/activate`);
API.deActivateAccount = userId => axios.post(`/auth/${userId}/deactivate`);

API.updatePassword = ({ userId, oldPassword, newPassword }) =>
    axios.post(`/auth/${userId}/updatePassword`, { oldPassword, newPassword });

/** Feedback */
API.addFeedback = ({ name, email, subject, message, type }) =>
    axios.post(`/feedback`, { name, email, subject, message, type });
API.updateFeedback = ({ feedbackId, status }) => axios.put(`/feedback/${feedbackId}`, { status });

API.getFeedbacks = () => axios.get(`/feedback`);

/** User */

API.updateMyself = data => axios.put(`${URI}/users/me`, data);
API.updateUser = (userId, data) => axios.put(`${URI}/users/${userId}`, data);
API.getUserById = userId => axios.get(`${URI}/users/${userId}`);
API.getPossibleInvitations = () => axios.get(`${URI}/users/athletes`);
API.getAllUsers = () => axios.get(`${URI}/users`);

/** Workouts **/

//Get All  Workouts
API.getAllWorkouts = () => axios.get(`${URI}/workouts`);

//Get Workout by Id
API.getWorkoutById = workoutId => axios.get(`${URI}/workouts/${workoutId}`);

//Get Workout by UserId
API.getUserWorkouts = userId => axios.get(`${URI}/workouts/users/${userId}`);

//Get workouts for all workout types by UserId
API.getAllUserWorkoutTypes = userId => axios.get(`${URI}/workouts/allTypes/users/${userId}`);

//Next sessions from `from` (browser local start of day), at most `limit` (dashboard)
API.getUpcomingWorkouts = (userId, { from, limit } = {}) =>
    axios.get(`${URI}/workouts/upcoming/users/${userId}`, {
        params: from ? { from: from.toISOString(), ...(limit && { limit }) } : undefined
    });

//Compact workouts for [from, to) (dashboard cards)
API.getAthleteWorkoutSummary = (userId, { from, to }) =>
    axios.get(`${URI}/workouts/users/${userId}/summary`, {
        params: { from: from.toISOString(), to: to.toISOString() }
    });

//Mark a past Assigned workout completed with its planned values
API.completeWorkout = workoutId => axios.post(`${URI}/workouts/${workoutId}/complete`);

const rangeParams = range =>
    range ? { params: { from: range.from.toISOString(), to: range.to.toISOString() } } : undefined;

//Get swimming styles statistics for a user (optional { from, to }; default all time)
API.getSwimmingStylesStats = (userId, range) =>
    axios.get(`${URI}/workouts/swimmingStyles/users/${userId}`, rangeParams(range));

//Get training zones statistics for a user (optional { from, to }; default all time)
API.getTrainingZonesStats = (userId, range) =>
    axios.get(`${URI}/workouts/trainingZones/users/${userId}`, rangeParams(range));

//Create Workout for User
API.addUserWorkout = (userId, body) => axios.post(`${URI}/workouts/users/${userId}`, body);
API.removeWorkout = workoutId => axios.delete(`${URI}/workouts/${workoutId}`);
API.updateWorkout = (workoutId, body) => axios.put(`${URI}/workouts/${workoutId}`, body);

//Update a Workout by Id
API.updateWorkoutById = (workoutId, body) => axios.put(`${URI}/workouts/${workoutId}`, body);

//Delete a workout
API.DeleteWorkoutById = workoutId => axios.delete(`${URI}/workouts/${workoutId}`);

API.DeleteAllWorkoutsForUser = userId => axios.delete(`${URI}/workouts/user/${userId}`);

API.getWorkoutStatsByUserId = userId => axios.get(`${URI}/stats/athlete/${userId}`);

API.getWorkoutStatsByCoachId = userId => axios.get(`${URI}/stats/coach/${userId}`);

/** Races **/

// Get all races
API.getAllRaces = () => axios.get(`${URI}/races`);

// Get all races for a specific user
API.getRacesByUserId = userId => axios.get(`${URI}/races/users/${userId}`);

// Get a specific race by ID
API.getRaceById = raceId => axios.get(`${URI}/races/${raceId}`);

// Create a race
API.createRace = (userId, raceData) => axios.post(`${URI}/races/users/${userId}`, raceData);

// Create a race but no splits
API.createRaceNoSplits = raceData => axios.post(`${URI}/races`, raceData);

// Update an existing race
API.updateRace = (raceId, raceData) => axios.put(`${URI}/races/${raceId}`, raceData);

// Update splits for a race by ID
API.updateRaceSplits = (raceId, splitsData) =>
    axios.put(`${URI}/races/${raceId}/splits`, splitsData);

// Delete race by ID
API.deleteRaceById = raceId => axios.delete(`${URI}/races/${raceId}`);

/** Tests **/

/** Tests 30*/

// Get all Tests30 tests for a user
API.getTest30TestsByUserId = userId => axios.get(`${URI}/tests/tests30/users/${userId}`);

// Create a new Test30 test
API.createTest30Test = (userId, test30Data) =>
    axios.post(`${URI}/tests/tests30/users/${userId}`, test30Data);

/** Test50 **/

// Get all Test50 tests for a specific user ID
API.getTest50TestsByUserId = userId => axios.get(`${URI}/tests/tests50/users/${userId}`);

// Create a new Test50 test
API.createTest50Test = (userId, test50Data) =>
    axios.post(`${URI}/tests/tests50/users/${userId}`, test50Data);

// Update an existing Test50 test
API.updateTest50Test = (test50Id, test50Data) =>
    axios.put(`${URI}/tests/tests50/${test50Id}`, test50Data);

// Delete a Test50 test by ID
API.deleteTest50TestById = test50Id => axios.delete(`${URI}/tests/tests50/${test50Id}`);

/** Test25 **/

// Get all Test25 tests for a user
API.getTest25TestsByUserId = userId => axios.get(`${URI}/tests/tests25/users/${userId}`);

// Create a new Test25 test
API.createTest25Test = (userId, test25Data) =>
    axios.post(`${URI}/tests/tests25/users/${userId}`, test25Data);

/** All Tests **/

// Get all tests (combined Test25, Test30, Test50)
API.getAllTestsForUser = userId => axios.get(`${URI}/tests/all/users/${userId}`);

/** Relationships **/

// Get all athletes associated with the logged-in coach
API.getAthletesById = coachId => axios.get(`${URI}/relationships/athletes/${coachId}`);

// Get all coaches associated with the logged-in athlete
API.getCoachesById = athleteId => axios.get(`${URI}/relationships/coaches/${athleteId}`);

// Get all pending relationship approvals for the logged-in user (either coach or athlete)
API.getMyPendingApprovals = () => axios.get(`${URI}/relationships/myPendingApprovals`);

// Get coaches associated with a specific athlete by athleteId
API.getCoachesForAthlete = athleteId =>
    axios.get(`${URI}/relationships/athlete/${athleteId}/coaches`);

// Get athletes associated with a specific coach by coachId
API.getAthletesForCoach = coachId => axios.get(`${URI}/relationships/coach/${coachId}/athletes`);

// Send a request from a coach to be an athlete's coach
API.requestToAthlete = (athleteEmail, coachId) =>
    axios.post(`${URI}/relationships/request/athlete/${athleteEmail}/coach/${coachId}`);

// Send a request from an athlete to be coached by a coach
API.requestToCoach = (coachId, athleteId) =>
    axios.post(`${URI}/relationships/request/coach/${coachId}/athlete/${athleteId}`);

// Approve a relationship by its ID with the logged-in user (either coach or athlete)
API.approveRelationshipById = relationshipId =>
    axios.patch(`${URI}/relationships/relationship/${relationshipId}/approve`);

// Remove a relationship by its ID with the logged-in user (either coach or athlete)
API.deleteRelationshipById = relationshipId =>
    axios.patch(`${URI}/relationships/relationship/${relationshipId}/remove`);

// Approve a relationship between an athlete and a coach (for admins)
API.approveRelationship = (athleteId, coachId) =>
    axios.patch(`${URI}/relationships/approve`, { athleteId, coachId });

// Delete a relationship between an athlete and a coach (for admins)
API.deleteRelationship = (athleteId, coachId) =>
    axios.patch(`${URI}/relationships/delete`, { athleteId, coachId });

// Delete a relationship record by its ID (for developers, testing purposes)
API.deleteRelationshipRecordById = relationshipId =>
    axios.delete(`${URI}/relationships/relationship/delete/${relationshipId}`);

API.createNewAthleteThroughRelationship = (userData, coachId) =>
    axios.post(`${URI}/relationships/coach/${coachId}`, userData);

/** Groups **/

// Get all groups for the logged-in coach
API.getMyGroups = coachId => axios.get(`${URI}/groups?coachId=${coachId}`);
// Create a group
API.createGroup = data => axios.post(`${URI}/groups`, data);
// Update a group
API.updateGroup = (groupId, data) => axios.put(`${URI}/groups/${groupId}`, data);
// Delete a group
API.deleteGroup = groupId => axios.delete(`${URI}/groups/${groupId}`);
// Get group by ID
API.getGroupById = groupId => axios.get(`${URI}/groups/${groupId}`);
// Add athlete to group
API.addAthleteToGroup = (groupId, athleteId) =>
    axios.post(`${URI}/groups/${groupId}/athletes/${athleteId}`);
// Remove athlete from group
API.removeAthleteFromGroup = (groupId, athleteId) =>
    axios.delete(`${URI}/groups/${groupId}/athletes/${athleteId}`);
// Get all athletes for a group
API.getAthletesForGroup = groupId => axios.get(`${URI}/groups/${groupId}/athletes`);

/** Programs **/

// Get all programs for a coach
API.getMyPrograms = coachId => axios.get(`${URI}/programs?coachId=${coachId}`);

// Get all programs
API.getAllPrograms = () => axios.get(`${URI}/programs`);

// Get a specific program by ID
API.getProgramById = programId => axios.get(`${URI}/programs/${programId}`);

// Create a new program
API.createProgram = programData => axios.post(`${URI}/programs`, programData);

// Update an existing program
API.updateProgram = (programId, programData) =>
    axios.put(`${URI}/programs/${programId}`, programData);

// Delete a program
API.deleteProgram = programId => axios.delete(`${URI}/programs/${programId}`);

/** Program Groups **/

// Create a new program group
API.createProgramGroup = (groupId, data) =>
    axios.post(`${URI}/programGroups/group/${groupId}`, data);

// Get all program groups for a group
API.getProgramGroupsByGroup = groupId => axios.get(`${URI}/programGroups/group/${groupId}`);

// Get future program groups for a group
API.getFutureProgramGroupsByGroup = groupId =>
    axios.get(`${URI}/programGroups/group/${groupId}/future`);

// Get past program groups for a group
API.getPastProgramGroupsByGroup = groupId =>
    axios.get(`${URI}/programGroups/group/${groupId}/past`);

// Get attendance data for a group
API.getGroupAttendance = groupId => axios.get(`${URI}/programGroups/group/${groupId}/attendance`);

// Update program group
API.updateProgramGroup = (programGroupId, data) =>
    axios.put(`${URI}/programGroups/${programGroupId}`, data);

// Delete program group
API.deleteProgramGroup = programGroupId => axios.delete(`${URI}/programGroups/${programGroupId}`);

// Get program snapshot from a program group
API.getProgramSnapshot = (programGroupId, workoutId) =>
    axios.get(`${URI}/programGroups/${programGroupId}/snapshot`, { params: { workoutId } });

// Get all program items for a program
API.getProgramItems = programId => axios.get(`${URI}/programs/${programId}/items`);

// Create a new program item
API.createProgramItem = (programId, itemData) =>
    axios.post(`${URI}/programs/${programId}/items`, itemData);

// Update a program item
API.updateProgramItem = (programId, programItemId, itemData) =>
    axios.put(`${URI}/programs/${programId}/items/${programItemId}`, itemData);

// Delete a program item
API.deleteProgramItem = (programId, programItemId) =>
    axios.delete(`${URI}/programs/${programId}/items/${programItemId}`);

// Reorder program items
API.reorderProgramItems = (programId, newOrder) =>
    axios.put(`${URI}/programs/${programId}/reorder`, { newOrder });

// Get sub-items of a program item
API.getSubItems = (programId, programItemId) =>
    axios.get(`${URI}/programs/${programId}/items/${programItemId}/sub-items`);

// Create a sub-item for a program item
API.createSubItem = (programId, programItemId, itemData) =>
    axios.post(`${URI}/programs/${programId}/items/${programItemId}/sub-items`, itemData);

// A coach's program-group sessions in [from, to) (Date objects; sent as ISO instants)
API.getCoachWeekPlan = (coachId, { from, to }) =>
    axios.get(`${URI}/programGroups/coach/${coachId}`, {
        params: { from: from.toISOString(), to: to.toISOString() }
    });

API.getAthletesWithLastWorkoutById = coachId =>
    axios.get(`${URI}/relationships/athletesWithLastWorkout/${coachId}`);

/** Admin dashboard reads (all admin-only; the server enforces it) **/
API.getAdminSignIns = ({ range, role, limit, cursor }) =>
    axios.get(`${URI}/admin/sign-ins`, { params: { range, role, limit, ...(cursor && { cursor }) } });
API.getAdminAccountActivity = () => axios.get(`${URI}/admin/account-activity`);
API.getBackupStatus = () => axios.get(`${URI}/admin/backups/status`);
API.getAdminRecentUsers = ({ days, limit } = {}) =>
    axios.get(`${URI}/admin/users/recent`, { params: { days, limit } });
API.getAdminFeedbackSummary = ({ boundaries }) =>
    axios.get(`${URI}/admin/feedback/summary`, {
        params: { boundaries: boundaries.map(b => b.toISOString()).join(',') }
    });

API.getAdminRecentFeedback = ({ limit } = {}) =>
    axios.get(`${URI}/admin/feedback/recent`, { params: { limit } });
API.getAdminActiveUsers = ({ limit } = {}) => axios.get(`${URI}/admin/active-users`, { params: { limit } });

/** Admin — database backup (admin-only; streams a zip file). */
API.downloadBackup = () =>
    axios.get(`${URI}/admin/backup`, {
        responseType: 'blob',
        timeout: 300000
    });

export default API;
